import { styled } from '@mui/material/styles';
import { globalZindex } from 'core/common/constants';
import { Container } from 'core/common/ui/ui-kit';

export const FooterLayoutStyled = styled('div')`
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: ${globalZindex.content};
  width: 100%;
  padding: 20px;

  @supports (padding: env(safe-area-inset-bottom)) {
    padding-bottom: calc(env(safe-area-inset-bottom) + 20px);
  }
`;

export const FooterLayoutBodyStyled = styled(Container)`
  width: 100%;
  padding-right: 0;
  padding-left: 0;
`;
